export const BOOMLINGS_URL = "https://www.boomlings.com";

export const GEOMETRY_DASH_URL = "https://www.geometrydash.com";

export const SFX_LIBRARY_VERSION_URL = "https://geometrydashfiles.b-cdn.net/sfx/sfxlibrary_version.txt";

export const MUSIC_LIBRARY_VERSION_URL = "https://geometrydashfiles.b-cdn.net/music/musiclibrary_version_02.txt";
